import React from "react";
import { Link } from "react-router-dom";
import { getImg } from "./utils";
import { logo, error } from "./pngs";
import "./App.scss";

export const ErrorPage = ({ title, subtitle }) => {
  return (
    <GenericPage logo={logo} image={error} title={title} subtitle={subtitle}>
      <div className="button-go-root">
        <Link to="/deeplink/"><button>Regresar al Inicio</button></Link>
      </div>
    </GenericPage>
  );
};

export const GenericPage = ({ logo, image, title, subtitle, children }) => {
  return (
    <div className="generic-page">
      {!logo ? null : <div className="logo">{getImg(logo)}</div>}
      {!image ? null : <div className="image">{getImg(image)}</div>}
      {!title && !subtitle ? null : (
        <div className="description">
          {!title ? null : <div className="title">{title}</div>}
          {!subtitle ? null : <div className="subtitle">{subtitle}</div>}
          {!children ? null : <div className="children">{children}</div>}
        </div>
      )}
    </div>
  );
};
